export default __webpack_public_path__ + "static/media/accident-page-1.d9c72485.png";